module.exports = __webpack_public_path__ + "img/bus_1.01221e23.png";